export default __webpack_public_path__ + "static/twoarrows-bf611706e94f35261494c2fcc4cab341.png";